import {_} from 'lodash';
import * as ko from "knockout";
import {ICompany} from "../../../index";
import {IMutableCompany} from ".";
import {StatusManager} from "./StatusManager";

const MUTABLE_COMPANY_KEYS = [
    'forcefullsync',
    'daystosyncstopwarning',
    'ignoreimportfilter',
    'ignoreimportfilteruntil',
    'importfilterdeactivated',
    'importfilterdeactivatedby',
    'importfilterdeactivatedbyorgnr',
    'maxdeletes',
    'maxedit',
    'maxnew',
    'pausedeltasync',
    'sendwarningonstop',
    'syncableedits',
    'syncendreportrecipients',
    'syncendreportsdeactivated',
    'syncendreportsdeactivatedby',
    'syncendreportsdeactivatedbyorgnr',
    'syncerrorreportrecipients',
    'syncstopwarningdeactivated',
    'syncstopwarningdeactivatedby',
    'syncstopwarningdeactivatedbyorgnr',
] as const satisfies readonly (keyof IMutableCompany)[];

type TMutableCompanyKey = (typeof MUTABLE_COMPANY_KEYS)[number];

export class MutableCompany {

    public readonly props: IMutableCompany = {}

    private company!: ICompany

    constructor(private statusManager: StatusManager) {
    }

    public init() {
        this.company = this.statusManager.company
        MUTABLE_COMPANY_KEYS.forEach((key: TMutableCompanyKey) => {
            const prop = this.props[key]
            if (!prop) {
                (this.props as Record<TMutableCompanyKey, KnockoutObservable<ICompany[TMutableCompanyKey]>>)[key]
                    = ko.observable(this.company[key])
            } else {
                (prop as KnockoutObservable<ICompany[TMutableCompanyKey]>)(this.company[key])
            }
        })
    }

    public getSubmitData = ko.pureComputed((): ICompany => {
        const keys = Object.keys(this.props) as TMutableCompanyKey[];
        const ret = this.getSubmitDataFromKeys(keys)
        return _.defaults(ret, this.company)
    })

    private getSubmitDataFromKeys(keys: TMutableCompanyKey[]): Partial<ICompany> {
        const ret: Partial<ICompany> = {}
        keys.forEach((key) => {
            const prop = this.props[key]
            if (prop) {
                const observable = prop as KnockoutObservable<ICompany[TMutableCompanyKey]>
                ;(ret as Record<TMutableCompanyKey, ICompany[TMutableCompanyKey]>)[key] = observable()
            } else {
                console.warn(`key ${key} not found in props`)
            }
        })
        return ret
    }

    public updateOriginalData(company: ICompany) {
        this.company = company
        MUTABLE_COMPANY_KEYS.forEach((key: TMutableCompanyKey) => {
            const prop = this.props[key] as KnockoutObservable<ICompany[TMutableCompanyKey]> | undefined
            prop?.(this.company[key])
        })
    }

    public discard() {
        MUTABLE_COMPANY_KEYS.forEach((key: TMutableCompanyKey) => {
            const prop = this.props[key] as KnockoutObservable<ICompany[TMutableCompanyKey]> | undefined
            prop?.(this.company[key])
        })
    }

    public submit(keys: (keyof ICompany)[]) {

        if (!keys.every(key => MUTABLE_COMPANY_KEYS.includes(key as TMutableCompanyKey) && this.props[key as TMutableCompanyKey])) {
            throw new Error(`(some) keys ${keys} not found in props`)
        }

        const submitData = this.getSubmitDataFromKeys(keys as TMutableCompanyKey[])

        return Promise.resolve()
            .then(() => this.statusManager.do_updatecompany(submitData))
    }

}
